import React from 'react';
import LoginForm from '../components/auth/LoginForm';
import { Container, Paper } from '@mui/material';

const LoginPage = () => {
  return (
    <Container component="main" maxWidth="sm">
       <Paper elevation={3} sx={{ mt: 8, p:4 }}>
            <LoginForm />
        </Paper>
    </Container>
  );
};

export default LoginPage;
